import { all, takeLatest, call, put } from 'redux-saga/effects';
import { fetchSiteMetadataActions } from '@/redux/actions';
import apiPortalService from '@/services/api-portal';
import { ActionType } from 'deox';
import { Organisation } from '@/types';

export function* fetchSiteMetadataSaga(
  action: ActionType<typeof fetchSiteMetadataActions.request>,
) {
  try {
    const { subdomain } = action.payload;

    const metadata: Organisation = yield call(apiPortalService.fetchMetadata, subdomain);
    yield put(fetchSiteMetadataActions.success({ organisation: metadata }));
  } catch (error) {
    yield put(fetchSiteMetadataActions.failure(error));
  }
}

export default function* root() {
  yield all([takeLatest(fetchSiteMetadataActions.request.type, fetchSiteMetadataSaga)]);
}
